import { APIError } from './apiError';

class AuthError extends APIError {}

export { AuthError };
export default AuthError;
